import axios from "axios"
import errorMsg from "./errorMsg"
import { customizeHeaders } from "./others"
import { goNativeLogin } from "./bridges"
import { Toast } from "antd-mobile"

const client = axios.create({
  baseURL: "",
  timeout: 15000,
})

const request = function (options) {
  // 请求成功
  const onSuccess = function (response) {
    console.log(response.request._url)
    console.log(response.data)
    const code = response.data.code
    // 0: 请求成功，1&10002 登陆过期
    if (code === 0) {
      return response.data
    } else if (code === 1 || code === 30 || code === 3) {
      goNativeLogin()
    }
    Toast.info(response.data.message)
    return Promise.reject(response.data)
  }

  //请求失败
  const onError = function (error) {
    console.error("Request Failed:", error)
    errorMsg(error)
    Toast.info(error.message)
    return Promise.reject(error.response || error.message)
  }

  //请求拦截
  client.interceptors.request.use(
    function (config) {
      config.headers = {
        ...config.headers,
        ...customizeHeaders(config.url, config.params, config.method),
      }
      return config
    },
    function (error) {
      return Promise.reject(error)
    }
  )
  // 响应拦截
  axios.interceptors.response.use(
    function (response) {
      return response
    },
    function (error) {
      return Promise.reject(error)
    }
  )

  // 发起请求
  return client(options).then(onSuccess).catch(onError)
}

export default request
